import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  memo,
  useMemo,
} from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { loader } from "../../../loader";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { postData } from "../../../axios/apiHelper";
import { ENDPOINT } from "../../../axios/apiConfig";
import { popup_alert } from "../../../popup_alert";
import { Modal, Dropdown, Accordion } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import Select, { createFilter } from "react-select";
import { getEmailData } from "../../../actions";
import { isValidEmail, normalizeEmail } from "../../../Utils/EmailValidayion";
import { countryRegionArray } from "../../../Utils/Country";

var old_object = {};
const VwdUserDetails = (props) => {
  const rdLikeArray = [
    "56Ek4feL/1A8mZgIKQWEqg==",
    "bWmUjqX7J011   WUTYn9g==",
    "MXl8m36VZFYXpgFVz3Pg0g==",
  ];
  const isLikeRdAccount = rdLikeArray.includes("FOkB/AUT2wGXRv ablqvbg==");
  const routeTypeSurvey = props?.type == "survey" ? 1 : 0;
  const [totalData, setTotalData] = useState({});
  const [siteNumberAll, setSiteNumberAll] = useState([]);
  const [siteNameAll, setSiteNameAll] = useState([]);
  const [role, setRole] = useState([]);
  const [irtRole, setIrtRole] = useState([]);

  const [irtInstitutionType, setIrtInstitutionType] = useState([]);
  const [nonIrtInstitutionType, setNonIrtInstitutionType] = useState([]);
  const [optIRT, setoptIRT] = useState([
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ]);
  const filterConfig = {
    matchFrom: "start",
  };
  const navigate = useNavigate();
  let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const location = useLocation();
  const [readers, setReaders] = useState([]);
  const [campaign_id_st, setCampaign_id] = useState();
  const [apiStatus, setApiStatus] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [removedReaders, setRemovedReaders] = useState([]);
  const [restrictedUsers, setRestrictedUsers] = useState([]);
  const [readersNewlyAdded, setReadersNewlyAdded] = useState([]);
  const [reRender, setReRender] = useState(0);
  const [update, setUpdate] = useState(0);
  const [activeManual, setActiveManual] = useState("active");
  const [editableData, setEditableData] = useState([]);
  const [counterFlag, setCounterFlag] = useState(0);
  const [countryall, setCountryall] = useState([]);
  const [irtCountry, setIRTCountry] = useState([]);
  const [saveOpen, setSaveOpen] = useState(false);
  const [editable, setEditable] = useState(0);
  const [updateCounter, setUpdateCounter] = useState(0);
  const [sortBy, setSortBy] = useState({
    hcp: "first_name",
    deleted: "first_name",
    added: "first_name",
    restricted: "first_name",
  });
  const [sortOrder, setSortOrder] = useState({
    hcp: "asc",
    deleted: "asc",
    added: "asc",
    restricted: "asc",
  });
  const [isVwdFlow, setIsVwdFlow] = useState(true);
  const surveyid = old_object?.survey_id
    ? old_object?.survey_id
    : props?.getDraftData?.campaign_data?.survey_id
      ? props?.getDraftData?.campaign_data?.survey_id
      : 0;
  const surveySubLinkId = old_object?.sublink_id
    ? old_object?.sublink_id
    : props?.getDraftData?.campaign_data?.sublink_id
      ? props?.getDraftData?.campaign_data?.sublink_id
      : 0;
  const priority = old_object?.priority
    ? old_object?.priority
    : props?.getDraftData?.campaign_data?.priority
      ? props?.getDraftData?.campaign_data?.priority
      : "Medium";
  const [hpc, setHpc] = useState([
    {
      firstname: "",
      lastname: "",
      email: "",
      contact_type: "",
      country: "",
      countryIndex: "",
      role: isLikeRdAccount ? irtRole?.[0]?.value : "",
      optIrt: isLikeRdAccount ? "yes" : "",
      institutionType: isLikeRdAccount ? irtInstitutionType?.[0]?.value : "",
      siteNumber: "",
      siteName: "",
    },
  ]);
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const [validationError, setValidationError] = useState({});

  useEffect(() => {
    const campaign_id =
      old_object?.campaign_id || props.getDraftData?.campaign_id || "";
    setCampaign_id(campaign_id);
  }, []);

  axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
  useEffect(() => {
    let oldRemovedHcp = old_object?.removedHcp || [];
    oldRemovedHcp =
      oldRemovedHcp.length > 0
        ? oldRemovedHcp
        : props.getDraftData?.campaign_data?.removedHcp || [];

    let oldAddedHcp = old_object?.addedHcp || [];
    oldAddedHcp =
      oldAddedHcp.length > 0
        ? oldAddedHcp
        : props.getDraftData?.campaign_data?.addedHcp ||
          props.getDraftData?.campaign_data?.newlyAdded ||
          [];

    const ibtValue =
      location?.state?.ibt ??
      old_object?.ibt ??
      props.getDraftData?.campaign_data?.ibt;
    if (ibtValue !== undefined) {
      setIsVwdFlow(true);
      old_object.ibt = ibtValue;

      const hasExistingData =
        old_object?.selectedHcp?.length > 0 ||
        props.getDraftData?.campaign_data?.selectedHcp?.length > 0;
      console.log(hasExistingData, "selectedHcp", location?.state?.ibt);
      if (hasExistingData) {
        const savedRestrictedUsers =
          old_object?.restrictedUsers ||
          props.getDraftData?.campaign_data?.restrictedUsers ||
          [];
        const savedRemovedHcp = oldRemovedHcp;
        const savedAddedHcp = oldAddedHcp;
        const readerHcp =
          old_object?.readerHcp ||
          props.getDraftData?.campaign_data?.readerHcp ||
          [];

        setReaders(readerHcp);
        setRestrictedUsers(savedRestrictedUsers);
        setRemovedReaders(savedRemovedHcp);
        setReadersNewlyAdded(savedAddedHcp);
        setApiStatus(true);
      } else {
        const fetchVwdUsers = async () => {
          loader("show");
          try {
            const response = await postData(ENDPOINT.VWD_USER_DETAILS, {
              ibt: ibtValue,
              priority: priority,
            });
            const stateUsers = response?.data?.data;

            if (stateUsers) {
              let pendingUsers = stateUsers;
              let restrictedUsers = [];
              let deletedUsers = [];

              const removedUsersData = [
                ...oldAddedHcp,
                ...oldRemovedHcp,
                ...(props.getDraftData?.campaign_data?.removedHcp?.length > 0
                  ? props.getDraftData?.campaign_data?.removedHcp
                  : []),
                ...(props.getDraftData?.campaign_data?.addedHcp?.length > 0
                  ? props.getDraftData?.campaign_data?.addedHcp
                  : []),
              ];

              pendingUsers = pendingUsers.filter((objFromA) => {
                if (objFromA?.is_restricted) {
                  restrictedUsers.push(objFromA);
                  return false;
                }
                if (objFromA?.is_deleted) {
                  deletedUsers.push(objFromA);
                  return false;
                }
                return !removedUsersData.find(
                  (objFromB) => objFromA?.user_id === objFromB?.user_id,
                );
              });

              setReaders(pendingUsers);
              setRemovedReaders([...oldRemovedHcp, ...deletedUsers]);
              setRestrictedUsers([...restrictedUsers]);
              setReadersNewlyAdded(oldAddedHcp);
              setApiStatus(true);
            }
          } catch (error) {
            console.error("API error:", error);
            toast.error("Failed to fetch VWD users");
          } finally {
            loader("hide");
          }
        };
        fetchVwdUsers();
      }
    } else {
     setIsVwdFlow(true);
      setReaders(props.getDraftData?.campaign_data?.selectedHcp);
      setApiStatus(true);
    }
  }, [props.getSelectedSmartListData, props.getDraftData]);

  useEffect(() => {
    if (props.getDraftData?.campaign_data) {
      props.getDraftData.campaign_data.addedHcp = readersNewlyAdded;
    }
    old_object.addedHcp = readersNewlyAdded;
  }, [readersNewlyAdded]);

  useEffect(() => {
    if (props.getDraftData?.campaign_data) {
      props.getDraftData.campaign_data.removedHcp = removedReaders;
    }
    old_object.removedHcp = removedReaders;
  }, [removedReaders]);

  useEffect(() => {
    if (props.getDraftData?.campaign_data) {
      props.getDraftData.campaign_data.restrictedUsers = restrictedUsers;
    }
    old_object.restrictedUsers = restrictedUsers;
  }, [restrictedUsers]);

  useEffect(() => {
    old_object.selectedHcp = readers;
    if (props.getDraftData?.campaign_data) {
      props.getDraftData.campaign_data.selectedHcp = readers;
    }
  }, [readers]);

  useEffect(() => {
    old_object.allusers = [...(readers || []), ...(readersNewlyAdded || [])];
    if (props.getDraftData?.campaign_data) {
      props.getDraftData.campaign_data.allusers = [
        ...readers,
        ...readersNewlyAdded,
      ];
    }
  }, [readers, readersNewlyAdded, removedReaders]);

  useEffect(() => {
    old_object.readerHcp = readers;
    if (props.getDraftData?.campaign_data) {
      props.getDraftData.campaign_data.readerHcp = readers;
    }
  }, [readers]);

  const backClicked = () => {
    console.log("backClicked", old_object);
    props.getEmailData(old_object);
    const backRoute = routeTypeSurvey
      ? "/survey/email/select-hcp"
      : isVwdFlow
        ? "/SelectVwdUser"
        : "/SelectSmartList";
    navigate(backRoute);
  };

  useEffect(() => {
    if (isLikeRdAccount) {
      axiosFun();
    }

    const getalCountry = async () => {
      let body = {
        user_id: "FOkB/AUT2wGXRv ablqvbg==",
      };
      // await axios
      //   .post(`distributes/filters_list`, body)
      //   .then((res) => {
      //     if (res.data.status_code == 200) {
      //       let country = res.data.response.data.country;
      //       let arr = [];

      //       Object.entries(country).map(([index, item]) => {
      //         let label = item;
      //         if (index == "B&H") {
      //           label = "Bosnia and Herzegovina";
      //         }
      //         arr.push({
      //           value: item,
      //           label: label,
      //         });
      //       });
      //       setCountryall(arr);

      //       if (isLikeRdAccount) {
      //         let investigator_type =
      //           res?.data?.response?.data?.investigator_type;
      //         let newType = [];
      //         Object.keys(investigator_type)?.map((item, i) => {
      //           newType.push({ label: item, value: item });
      //         });
      //         let irt_inverstigator_type =
      //           res?.data?.response?.data?.irt_inverstigator_type;
      //         let newIrtType = [];
      //         Object.keys(irt_inverstigator_type)?.map((item, i) => {
      //           newIrtType.push({ label: item, value: item });
      //         });

      //         let non_irt_institution_type =
      //           res?.data?.response?.data?.non_mandatory_institution_type;

      //         let nonIrtInstitution = [];
      //         Object.keys(non_irt_institution_type)?.map((item, i) => {
      //           nonIrtInstitution.push({ label: item, value: item });
      //         });

      //         setNonIrtInstitutionType(nonIrtInstitution);

      //         let irt_institution_type =
      //           res?.data?.response?.data?.irt_institution_type;

      //         let newIrtInstitution = [];
      //         Object.keys(irt_institution_type)?.map((item, i) => {
      //           newIrtInstitution.push({ label: item, value: item });
      //         });

      //         setIrtInstitutionType(newIrtInstitution);

      //         setRole(newType);
      //         setIrtRole(newIrtType);
      //       }

      //       setTotalData(res.data.response.data);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    };
    getalCountry();
  }, []);

  const saveAsDraft = async () => {
    console.log("=== SAVE AS DRAFT DEBUG ===");

    const body = {
      user_id: "FOkB/AUT2wGXRv ablqvbg==",
      pdf_id: old_object?.PdfSelected
        ? old_object.PdfSelected
        : props.getDraftData?.pdf_id,
      description: old_object?.emailDescription
        ? old_object.emailDescription
        : props.getDraftData?.description
          ? props.getDraftData.description
          : "",
      creator: old_object?.emailCreator
        ? old_object.emailCreator
        : props.getDraftData?.creator
          ? props.getDraftData.creator
          : "",
      campaign_name: old_object?.emailCampaign
        ? old_object.emailCampaign
        : props.getDraftData?.campaign,
      subject: old_object?.emailSubject
        ? old_object.emailSubject
        : props.getDraftData?.subject,
      route_location: routeTypeSurvey
        ? "survey/email/select-smartlist-users"
        : isVwdFlow
          ? "VwdUsers"
          : "SelectSmartListUsers",
      tags: old_object?.tags ? old_object.tags : props.getDraftData?.tags,
      campaign_data: {
        template_id: old_object?.templateId
          ? old_object.templateId
          : props.getDraftData?.campaign_data?.template_id,
        smart_list_id: props.getSelectedSmartListData?.id
          ? props.getSelectedSmartListData.id
          : props.getDraftData?.campaign_data?.smart_list_id,
        readerHcp: [...readers],
        selectedHcp: [...readers, ...readersNewlyAdded],
        list_selection: old_object?.selected
          ? old_object.selected
          : props.getDraftData?.campaign_data?.list_selection
            ? props.getDraftData.campaign_data.list_selection
            : 0,
        removedHcp: removedReaders,
        addedHcp: readersNewlyAdded,
        restrictedUsers: restrictedUsers,
        sublink_id: old_object?.sublink_id
          ? old_object.sublink_id
          : surveySubLinkId,
        survey_id: old_object?.survey_id ? old_object.survey_id : surveyid,
        ibt: location?.state?.ibt ?? old_object?.ibt,
        priority:priority
      },
      campaign_id: campaign_id_st,
      source_code: old_object?.template
        ? old_object.template
        : props.getDraftData?.source_code,
      status: 2,
    };
    axios.defaults.baseURL = process.env.REACT_APP_API_KEY;

    loader("show");
    await axios
      .post(`emailapi/save_draft`, body)
      .then((res) => {
        if (res.data.status_code == 200) {
          setCampaign_id(res.data.response.data.id);
          const redirectRoute = routeTypeSurvey
            ? "/survey/email"
            : isVwdFlow
              ? "/vwd/email"
              : "/EmailList";
          popup_alert({
            visible: "show",
            message: "Your changes has been saved <br />successfully !",
            type: "success",
            redirect: redirectRoute,
          });
          loader("hide");
        } else {
          toast.warning(res.data.message);
          loader("hide");
        }
      })
      .catch((err) => {
        loader("hide");
        toast.error("Something went wrong");
      });
  };

  const nextClicked = () => {
    const nextRoute = routeTypeSurvey
      ? "/survey/email/verify-mail"
      : isVwdFlow
        ? "/vwd/email/verifyMAIL"
        : "/verifyMAIL";

    props.getEmailData({
      ...old_object,
      newlyAdded: readersNewlyAdded,
      removed: removedReaders,
    });

    navigate(nextRoute, {
      state: {
        selectedHcp: [...readers, ...readersNewlyAdded],
        removedHcp: removedReaders,
        ibt: location?.state?.ibt ?? old_object?.ibt,
      },
    });
  };

  const axiosFun = async () => {
    try {
      const result = await axios.get(
        `emailapi/get_site?uid=${
          "FOkB/AUT2wGXRv ablqvbg==" == "bWmUjqX7J011   WUTYn9g=="
            ? 298217
            : 2147501188
        }`,
      );

      let country = result?.data?.response?.data?.site_country_data;
      let arr = [];
      Object.entries(country).map(([index, item]) => {
        let label = item;
        if (index == "B&H") {
          label = "Bosnia and Herzegovina";
        }
        arr.push({
          value: item,
          label: label,
        });
      });
      setIRTCountry(arr);
    } catch (err) {
      console.log("-err", err);
    }
  };

  const onFirstNameChange = (e, i) => {
    const { value } = e.target;
    const list = [...hpc];
    const name = hpc[i].firstname;
    list[i].firstname = value;
    setHpc(list);
  };

  const onLastNameChange = (e, i) => {
    const { value } = e.target;
    const list = [...hpc];
    const name = hpc[i].lastname;
    list[i].lastname = value;
    setHpc(list);
  };

  const onEmailChange = (e, i) => {
    const { value } = e.target;
    const list = [...hpc];
    const name = hpc[i].email;
    list[i].email = value;
    setHpc(list);
  };

  const onRoleChange = (e, i) => {
    if (e == "") {
      const list = [...hpc];
      list[i].role = "";
      setHpc(list);
    } else {
      const value = e?.value;
      const list = [...hpc];
      const name = hpc[i].role;
      list[i].role = value;
      setHpc(list);
    }
  };

  const onInstitutionChange = (e, i) => {
    if (e == "") {
      const list = [...hpc];
      list[i].institutionType = "";
      list[i].optIRT = "";
      list[i].role = "";
      list[i].country = "";
      setHpc(list);
    } else {
      const value = e?.value;
      const list = [...hpc];
      const name = hpc[i].institutionType;
      list[i].institutionType = value;
      setHpc(list);
    }
  };

  const onIRTChange = (e, i) => {
    if (e == "") {
      const list = [...hpc];
      list[i].optIrt = "";
      list[i].role = "";
      list[i].country = "";
      setHpc(list);
    } else {
      const value = e;
      const list = [...hpc];
      const name = hpc[i].optIrt;
      list[i].optIrt = value;
      list[i].role = e == "yes" ? irtRole?.[0]?.value : "Other";
      list[i].country = "";
      list[i].siteNumberIndex = "";
      list[i].siteNameIndex = "";
      list[i].siteName = "";
      list[i].siteNumber = "";
      list[i].institutionType =
        e == "yes" ? irtInstitutionType?.[0]?.value : "";
      setHpc(list);
    }
    let arr = [];
    setSiteNumberAll(arr);
    setSiteNameAll(arr);
    setCounterFlag(counterFlag + 1);
  };

  const onContactTypeChange = (e, i) => {
    const value = e;
    const list = [...hpc];
    const name = hpc[i].contact_type;
    list[i].contact_type = value;
    setHpc(list);
  };

  const onCountryChange = (e, i) => {
    if (e == null) {
      const list = [...hpc];
      list[i].country = "";
      list[i].countryIndex = "";
      setHpc(list);
    } else {
      if (isLikeRdAccount) {
        let consetValue = e.value;
        if (e.value == "B&H") {
          consetValue = "Bosnia and Herzegovina";
        }
        const matchingKeys = Object.entries(totalData.site_country_data)
          .filter(([key, value]) => value === consetValue)
          .map(([key, value]) => key);
        const filteredSiteNames = matchingKeys.map((key) => ({
          label: totalData.site_data[key],
          value: totalData.site_data[key],
        }));
        const siteNumbers = matchingKeys.map((key) => ({
          label: key,
          value: key,
        }));
        setSiteNumberAll(siteNumbers);
        setSiteNameAll(filteredSiteNames);
      }
      const value = e.value;
      const list = [...hpc];
      const name = hpc[i].country;
      list[i].country = value;
      list[i].siteNumberIndex = "";
      list[i].siteNameIndex = "";
      list[i].siteName = "";
      list[i].siteNumber = "";
      setHpc(list);
    }
  };

  const onSiteNumberChange = (e, i) => {
    if (e == null) {
      const list = [...hpc];
      list[i].siteNumber = "";
      setHpc(list);
    } else {
      let getSiteData = totalData.site_data;
      let site_name_value = getSiteData[e.value];
      const value = e.value;
      const list = [...hpc];
      const name = hpc[i].siteNumber;
      list[i].siteNumber = value;
      list[i].siteName = site_name_value;
      let snameindex = siteNameAll.findIndex(
        (x) => x.value === site_name_value,
      );
      list[i].siteNameIndex = snameindex;
      let index = siteNumberAll.findIndex((x) => x.value === value);
      list[i].siteNumberIndex = index;
      setHpc(list);
    }
  };

  const onSiteNameChange = (e, i) => {
    if (e == null) {
      const list = [...hpc];
      list[i].siteName = "";
      setHpc(list);
    } else {
      const value = e.value;
      let getSiteData = totalData.site_data;
      let site_number_value = Object.keys(getSiteData).find(
        (key) => getSiteData[key] === e.value,
      );
      const list = [...hpc];
      const name = hpc[i].siteName;
      list[i].siteName = value;
      list[i].siteNumber = site_number_value;
      let snameindex = siteNumberAll.findIndex(
        (x) => x.value === site_number_value,
      );
      list[i].siteNumberIndex = snameindex;
      let index = siteNameAll.findIndex((x) => x.value === value);
      list[i].siteNameIndex = index;
      setHpc(list);
    }
  };

  const deleteRecord = (i) => {
    const list = hpc;

    list.splice(i, 1);

    setHpc(list);
    setCounterFlag(counterFlag + 1);
  };

  const readersAdded = (reader, i) => {
    const readersRemoved = removedReaders;
    readersRemoved.splice(i, 1);
    setRemovedReaders(readersRemoved);

    setReaders((oldArray) => [reader, ...oldArray]);
    setReRender(reRender + 1);
  };

  const addRestrictedToNewlyAdded = (reader, index) => {
    const updatedRestricted = [...restrictedUsers];
    updatedRestricted.splice(index, 1);
    setRestrictedUsers(updatedRestricted);
    setReadersNewlyAdded((oldArray) => [reader, ...oldArray]);
    setUpdate(update + 1);
  };

  const removeNewlyAddedToRestricted = (reader, index) => {
    const updatedNewlyAdded = [...readersNewlyAdded];
    updatedNewlyAdded.splice(index, 1);
    setReadersNewlyAdded(updatedNewlyAdded);
    setRestrictedUsers((oldArray) => [reader, ...oldArray]);
    setUpdate(update + 1);
  };

  const addMoreHcp = () => {
    const status = hpc.map((data) => {
      if (isLikeRdAccount) {
        if (
          data?.email == "" ||
          data?.institutionType == "" ||
          data.last_name == "" ||
          data.first_name == "" ||
          data.country == "" ||
          data?.role == "" ||
          (data?.optIrt === "yes" &&
            (data?.siteNumber === "" || data?.siteName === ""))
        ) {
          return "false";
        } else {
          return "true";
        }
      } else {
        if (data.email == "") {
          return "false";
        } else {
          return "true";
        }
      }
    });

    if (status.every((element) => element == "true")) {
      setHpc([
        ...hpc,
        {
          firstname: "",
          lastname: "",
          email: "",
          contact_type: "",
          country: "",
          countryIndex: "",
          role: isLikeRdAccount ? irtRole?.[0]?.value : "",
          optIrt: isLikeRdAccount ? "yes" : "",
          institutionType: isLikeRdAccount
            ? irtInstitutionType?.[0]?.value
            : "",
          siteNumber: "",
          siteName: "",
        },
      ]);
    } else {
      if (isLikeRdAccount) {
        toast.warning("Please input the required fields.");
      } else {
        toast.warning("Please input the required fields.");
      }
    }
  };

  const editing = (user_id, email) => {
    if (editable != 0) {
      const name_edit = document.getElementById(
        "field_name" + user_id,
      ).innerText;
      const country_edit = document.getElementById(
        "field_country" + user_id,
      ).value;
      const role_edit =
        document.getElementById("field_role" + user_id)?.innerText || "";
      const company_edit =
        document.getElementById("field_company" + user_id)?.innerText || "";
      const region_edit =
        document.getElementById("field_region" + user_id)?.innerText || "";

      const arr = [];
      arr.push({
        user_id: user_id,
        email: email,
        company: company_edit,
        country: country_edit,
        username: name_edit,
        role: role_edit,
        region: region_edit,
      });

      let prev_obj = editableData.find((x) => x.user_id === user_id);
      if (typeof prev_obj != "undefined") {
        editableData.map(
          (obj) => arr.find((o) => o.user_id === user_id) || obj,
        );
      } else {
        setEditableData((oldArray) => [...oldArray, ...arr]);
      }
    }
  };

  const deleteReader = (i) => {
    const previous_removed_users = removedReaders;
    const readersList = readers;
    const removedReader = readersList.splice(i, 1);
    setReaders(readersList);
    setRemovedReaders((oldArray) => [...oldArray, removedReader[0]]);
    let merged_array = [...previous_removed_users, ...removedReader];
    old_object.removedHcp = merged_array;

    if (props.getDraftData?.campaign_data) {
      if (props.getDraftData.campaign_data?.removedHcp) {
        props.getDraftData.campaign_data.removedHcp = merged_array;
      }
    }
  };

  const saveEditClicked = async () => {
    setEditable(0);
    if (editableData.length > 0) {
      const tempArr = [
        ...restrictedUsers,
        ...readersNewlyAdded,
        ...removedReaders,
        ...readers,
      ];
      editableData.map((data) => {
        const name_edit = document.getElementById(
          "field_name" + data.user_id,
        ).innerText;
        let country_edit = document.getElementById(
          "field_country" + data.user_id,
        ).value;
        const edit_index = document.getElementById(
          "field_index" + data.user_id,
        ).value;
        const role_edit =
          document.getElementById("field_role" + data.user_id)?.innerText || "";
        const company_edit =
          document.getElementById("field_company" + data.user_id)?.innerText ||
          "";
        let region_edit =
          document.getElementById("field_region" + data.user_id)?.innerText ||
          "";

        const user = tempArr.find((item) => item.user_id === data.user_id);
        if (user) {
          country_edit = user?.selectedCountries?.value;
          region_edit = user?.selectedRegion?.value;
        }
        let prev_obj = readers.find((x) => x.user_id === data.user_id);
        if (typeof prev_obj != "undefined") {
          if (typeof readers[edit_index] != "undefined") {
            readers[edit_index].country = country_edit;
            readers[edit_index].role = role_edit;
            readers[edit_index].company = company_edit;
            readers[edit_index].region = region_edit;
          }
        } else {
          if (typeof readersNewlyAdded[edit_index] != "undefined") {
            readersNewlyAdded[edit_index].country = country_edit;
            readersNewlyAdded[edit_index].role = role_edit;
            readersNewlyAdded[edit_index].company = company_edit;
            readersNewlyAdded[edit_index].region = region_edit;
          }
        }
        data.country = country_edit;
        data.username = name_edit;
        data.role = role_edit;
        data.company = company_edit;
        data.region = region_edit;
      });
      const body = {
        user_id: "FOkB/AUT2wGXRv ablqvbg==",
        edit_list_array: editableData,
      };
      setSaveOpen(false);
      axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
      loader("show");

      await postData(`/vwd/update-vwd-user-details`, body)
        .then((res) => {
          loader("hide");
          if (res.data.status_code === 200) {
            toast.success("List updated");
          } else {
            popup_alert({
              visible: "show",
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
        });
      setEditableData([]);
      setSaveOpen(false);
    } else {
      setSaveOpen(false);
      loader("hide");
      toast.warning("No row update");
    }
  };

  const closeClicked = () => {
    setSaveOpen(false);
    setEditable(0);
    let vr = readers;
    setReaders([]);
    setTimeout(() => {
      setReaders(vr);

      setUpdateCounter(updateCounter + 1);
    }, 50);
  };

  const saveClicked = async () => {
    const isRdAndNorgianAcount = isLikeRdAccount;

    if (activeManual == "active") {
      const body_data = hpc.map((data) => {
        if (isRdAndNorgianAcount) {
          return {
            first_name: data.firstname,
            last_name: data.lastname,
            email: data.email,
            country: data.country,
            contact_type: data?.contact_type ? data?.contact_type : "",
            siteNumber: data?.siteNumber ? data.siteNumber : "",
            siteName: data.siteName ? data.siteName : "",
            investigator_type: data?.role,
            siteIrt: data?.optIrt == "yes" ? 1 : 0,
            institution_type: data?.institutionType
              ? data?.institutionType
              : "",
          };
        } else {
          return {
            first_name: data.firstname,
            last_name: data.lastname,
            email: data.email,
            country: data.country,
            contact_type: data.contact_type,
          };
        }
      });

      const body = {
        data: body_data,
        user_id: "FOkB/AUT2wGXRv ablqvbg==",
        smart_list_id: "",
      };

      const status = body.data.map((data, index) => {
        if (
          data.email == "" ||
          data?.institution_type == "" ||
          data?.siteNumber == "" ||
          data?.siteName == "" ||
          data.first_name == "" ||
          data.last_name == "" ||
          data.country == "" ||
          data?.investigator_type == ""
        ) {
          if (data.first_name == "" && isRdAndNorgianAcount) {
            setValidationError({
              newHcpFirstName: "Please enter the first name",
              index: index,
            });
            return;
          }
          if (data.last_name == "" && isRdAndNorgianAcount) {
            setValidationError({
              newHcpLastName: "Please enter the last name",
              index: index,
            });
            return;
          }
          if (data.email == "") {
            setValidationError({
              newHcpEmail: "Please enter the email atleast",
              index: index,
            });

            return;
          }
          if (data.email != "") {
            let email = data.email;
            let useremail = email.trim().toLowerCase();

            if (!isValidEmail(useremail)) {
              setValidationError({
                newHcpEmail: "Email format is not valid",
                index: index,
              });
              return;
            }

            let prev_obj = readers.find(
              (x) => x.email.toLowerCase() === useremail,
            );
            let prev_obj_new = readersNewlyAdded.find(
              (x) => x.email.toLowerCase() === useremail,
            );

            if (
              typeof prev_obj !== "undefined" ||
              typeof prev_obj_new !== "undefined"
            ) {
              setValidationError({
                newHcpEmail: "User with same email already added in list.",
                index: index,
              });
              return;
            }

            const normalizedNew = normalizeEmail(useremail);
            let similarMatch = [...readers, ...readersNewlyAdded].find((x) => {
              const normalizedExisting = normalizeEmail(x.email);
              return normalizedExisting === normalizedNew;
            });

            if (typeof similarMatch !== "undefined") {
              setValidationError({
                newHcpEmail:
                  "User with a similar email already exists in the list.",
                index: index,
              });
              return;
            }

            return "true";
          }
          if (data.institution_type == "" && isRdAndNorgianAcount) {
            setValidationError({
              newHcpInstitution: "Please select the institution type",
              index: index,
            });
            return;
          }
          if (data.investigator_type == "" && isRdAndNorgianAcount) {
            setValidationError({
              role: "Please select the role ",
              index: index,
            });
            return;
          }

          if (data.country == "" && isRdAndNorgianAcount) {
            setValidationError({
              newHcpCountry: "Please select the country",
              index: index,
            });
            return;
          }

          if (data?.siteIrt == 1) {
            if (data.siteNumber === "" && isRdAndNorgianAcount) {
              setValidationError({
                newSiteNumber: "Please select the site number ",
                index: index,
              });
              return;
            }
            if (data.siteName === "" && isRdAndNorgianAcount) {
              setValidationError({
                newSiteName: "Please select the site name",
                index: index,
              });
              return;
            }
          }

          return "true";
        }
      });
      status.sort();
      if (status.every((element) => element == "true")) {
        loader("show");

        axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
        await axios
          .post(`distributes/add_new_readers_in_list`, body)
          .then((res) => {
            if (res.data.status_code === 200) {
              toast.success("User added successfully");
              res.data.response.data.map((data) => {
                setReadersNewlyAdded((oldArray) => [data, ...oldArray]);
              });
              setIsOpenAdd(false);
            } else {
              toast.warning(res.data.message);
              loader("hide");
            }
            loader("hide");
          })
          .catch((err) => {
            loader("hide");
            toast.error("Something went wrong");
          });
      } else {
        const filteredArray = status.filter((value) => value !== "true");
        toast.warning(filteredArray?.[0]);
      }
    } else {
      let formData = new FormData();
      let user_id = "FOkB/AUT2wGXRv ablqvbg==";
      formData.append("user_id", user_id);
      formData.append("smart_list_id", "");
      formData.append("reader_file", selectedFile);

      axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
      if (selectedFile) {
        loader("show");
        await axios
          .post(`distributes/update_reader_list`, formData)
          .then((res) => {
            if (res.data.status_code === 200) {
              res.data.response.data.map((data) => {
                setReadersNewlyAdded((oldArray) => [...oldArray, data]);
              });
              setIsOpenAdd(false);
              setActiveManual("active");
              setSelectedFile(null);
              loader("hide");
              toast.success("user added successfully");
            } else {
              toast.warning(res.data.message);
              loader("hide");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toast.warning("Please add a excel file");
      }
    }
  };

  const editButtonClicked = () => {
    setSaveOpen(true);

    let temp_val = 1 - editable;
    setEditable(temp_val);
    setUpdate(update + 1);
  };

  const handleSort = (key, type) => {
    setSortBy((prev) => ({ ...prev, [type]: key }));
    setSortOrder((prev) => ({
      ...prev,
      [type]: prev[type] === "asc" ? "desc" : "asc",
    }));
  };

  const sortData = (data, key, order) => {
    return [...data].sort((a, b) => {
      let valueA = a[key];
      let valueB = b[key];

      if (typeof valueA === "number" && typeof valueB === "number") {
        return order === "asc" ? valueA - valueB : valueB - valueA;
      } else if (key === "created" || key === "lastActivity") {
        return order === "asc"
          ? new Date(valueA || 0) - new Date(valueB || 0)
          : new Date(valueB || 0) - new Date(valueA || 0);
      } else {
        return order === "asc"
          ? (valueA || "")?.toString().localeCompare((valueB || "")?.toString())
          : (valueB || "")
              ?.toString()
              .localeCompare((valueA || "")?.toString());
      }
    });
  };

  // Helper function to render table row with editable fields
  const renderTableRow = (reader, index, listType) => {
    return (
      <TableRow
        reader={reader}
        index={index}
        listType={listType}
        setRestrictedUsers={setRestrictedUsers}
        setReadersNewlyAdded={setReadersNewlyAdded}
        setRemovedReaders={setRemovedReaders}
        setReaders={setReaders}
        editable={editable}
        isVwdFlow={isVwdFlow}
        addRestrictedToNewlyAdded={addRestrictedToNewlyAdded}
        removeNewlyAddedToRestricted={removeNewlyAddedToRestricted}
        readersAdded={readersAdded}
        deleteReader={deleteReader}
        editing={editing}
      />
    );
  };

  const sections = [
    {
      label: "Restricted",
      data: restrictedUsers,
      type: "restricted",
      className: "content_unsubscribed",
      key: "5",
    },
    {
      label: "Added",
      data: readersNewlyAdded,
      type: "added",
      className: "content_added",
      key: "6",
    },
    {
      label: "Deleted",
      data: removedReaders,
      type: "deleted",
      className: "content_deleted",
      key: "7",
    },
    {
      label: "Users",
      data: readers,
      type: "hcp",
      className: "content_hcps",
      key: "4",
    },
  ];

  return (
    <>
      <div className="col right-sidebar custom-change">
        <div className="custom-container">
          <div className="row">
            <div className="page-top-nav sticky">
              <div className="row justify-content-end align-items-center">
                <div className="col-12 col-md-1">
                  <div className="header-btn-left">
                    <button
                      className="btn btn-primary btn-bordered back"
                      onClick={backClicked}
                    >
                      Back
                    </button>
                  </div>
                </div>
                <div className="col-12 col-md-8">
                  <ul className="tabnav-link">
                    <li className="active">
                      <Link to="/vwd/EmailArticleSelect">Select Content</Link>
                    </li>
                    <li className="active">
                      <Link to="/vwd/CreateEmail">Create Your Email</Link>
                    </li>
                    <li className="active">
                      <Link
                        to={
                          routeTypeSurvey
                            ? "/survey/email/smart-list"
                            : isVwdFlow
                              ? "/SelectVwdUser"
                              : "/SelectSmartList"
                        }
                      >
                        Select Users
                      </Link>
                    </li>

                    <li className="active active-main">
                      <Link
                        to={
                          routeTypeSurvey
                            ? "/survey/email/select-smartlist-users"
                            : isVwdFlow
                              ? "/VwdUsers"
                              : "/SelectSmartListUsers"
                        }
                      >
                        Verify Your List
                      </Link>
                    </li>

                    <li className="">
                      <a href="#">Verify Your Email</a>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-md-3">
                  <div className="header-btn">
                    {isLikeRdAccount ? (
                      <Link
                        to={"/EmailList"}
                        className="btn btn-primary btn-bordered move-draft engine_cancel"
                      >
                        Cancel
                      </Link>
                    ) : null}
                    <button
                      className="btn btn-primary btn-bordered "
                      onClick={saveAsDraft}
                      disabled={
                        readers?.length < 1 && readersNewlyAdded?.length < 1
                      }
                    >
                      Save As Draft
                    </button>
                    <button
                      className="btn btn-primary btn-filled next"
                      onClick={nextClicked}
                      disabled={
                        readers?.length < 1 && readersNewlyAdded?.length < 1
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {apiStatus && (
              <section className="search-hcp">
                <div className="result-hcp-table">
                  <div className="table-title">
                    <h4 className="d-flex">
                      <div className="ml-3">Users</div>
                    </h4>
                    <div className="selected-hcp-table-action">
                      {editable == false ? (
                        <>
                          <div className="hcp-added">
                            <button
                              className="btn btn-outline-primary"
                              onClick={editButtonClicked}
                            >
                              <img src={path_image + "edit.svg"} alt="Edit" />
                            </button>
                          </div>
                          <div className="hcp-sort"></div>
                        </>
                      ) : null}
                      {saveOpen ? (
                        <>
                          <button
                            className="btn btn-primary btn-filled"
                            onClick={closeClicked}
                          >
                            Close
                          </button>

                          <button
                            className="btn btn-primary btn-bordered"
                            onClick={saveEditClicked}
                          >
                            Save
                          </button>
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div className="email-unsubscribe">
                    <Accordion
                      alwaysOpen
                      className="content_analytics_accordian"
                    >
                      {sections.map(
                        (section) =>
                          (section.data?.length > 0 ||
                            section.type === "hcp") && (
                            <Accordion.Item
                              eventKey={section.key}
                              className={section.className}
                              key={section.key}
                            >
                              <Accordion.Header>
                                {section.label}{" "}
                                <span>| {section.data?.length || 0}</span>
                              </Accordion.Header>
                              <Accordion.Body>
                                <UserTable
                                  data={section.data}
                                  type={section.type}
                                  sortBy={sortBy}
                                  sortOrder={sortOrder}
                                  handleSort={handleSort}
                                  sortData={sortData}
                                  renderTableRow={renderTableRow}
                                />
                              </Accordion.Body>
                            </Accordion.Item>
                          ),
                      )}
                    </Accordion>
                  </div>
                </div>
              </section>
            )}
          </div>
        </div>
      </div>

      <Modal
        id="add_hcp"
        show={isOpenAdd}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              {isLikeRdAccount ? "Add New User +" : "Add New HCP"}
            </h5>
            <button
              onClick={() => {
                setIsOpenAdd(false);
                setHpc([
                  {
                    firstname: "",
                    lastname: "",
                    email: "",
                    contact_type: "",
                    country: "",
                    countryIndex: "",
                    role: isLikeRdAccount ? irtRole?.[0]?.value : "",
                    optIrt: isLikeRdAccount ? "yes" : "",
                    institutionType: isLikeRdAccount
                      ? irtInstitutionType?.[0]?.value
                      : "",
                    siteNumber: "",
                    siteName: "",
                  },
                ]);
                setActiveManual("active");
              }}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="hcp-add-box">
              <div className="hcp-add-form tab-content">
                <form id="add_hcp_form" className={"tab-pane" + activeManual}>
                  {hpc.map((val, i) => {
                    const fieldName = `hpc[${i}]`;
                    return (
                      <React.Fragment key={fieldName}>
                        <div className="add_hcp_boxes">
                          <div className="form_action">
                            <div className="row">
                              <div className="col-12 col-md-6">
                                <div className="form-group">
                                  <label htmlFor="">
                                    First name{" "}
                                    {isLikeRdAccount && <span>*</span>}{" "}
                                  </label>
                                  <input
                                    type="text"
                                    className={
                                      validationError?.newHcpFirstName &&
                                      validationError?.index == i
                                        ? "form-control error"
                                        : "form-control"
                                    }
                                    onChange={(event) =>
                                      onFirstNameChange(event, i)
                                    }
                                    value={val.firstname}
                                    placeholder="First name"
                                  />
                                  {validationError?.newHcpFirstName &&
                                  validationError?.index == i ? (
                                    <div className="login-validation">
                                      {validationError?.newHcpFirstName}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div className="form-group">
                                  <label htmlFor="">
                                    Last name{" "}
                                    {isLikeRdAccount && <span>*</span>}{" "}
                                  </label>
                                  <input
                                    type="text"
                                    className={
                                      validationError?.newHcpLastName &&
                                      validationError?.index == i
                                        ? "form-control error"
                                        : "form-control"
                                    }
                                    onChange={(event) =>
                                      onLastNameChange(event, i)
                                    }
                                    value={val.lastname}
                                    placeholder="Last name"
                                  />
                                  {validationError?.newHcpLastName &&
                                  validationError?.index == i ? (
                                    <div className="login-validation">
                                      {validationError?.newHcpLastName}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col-12 col-md-6">
                                <div className="form-group">
                                  <label htmlFor="">
                                    Email <span>*</span>
                                  </label>
                                  <input
                                    type="email"
                                    className={
                                      validationError?.newHcpEmail &&
                                      validationError?.index == i
                                        ? "form-control error"
                                        : "form-control"
                                    }
                                    id="email-desc"
                                    name={`${fieldName}.email`}
                                    onChange={(event) =>
                                      onEmailChange(event, i)
                                    }
                                    value={val.email}
                                    placeholder="example@email.com"
                                  />
                                  {validationError?.newHcpEmail &&
                                  validationError?.index == i ? (
                                    <div className="login-validation">
                                      {validationError?.newHcpEmail}
                                    </div>
                                  ) : null}
                                </div>
                              </div>

                              {isLikeRdAccount ? (
                                <>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group">
                                      <label for="">
                                        IRT mandatory training
                                      </label>
                                      <Select
                                        options={optIRT}
                                        className="dropdown-basic-button split-button-dropup edit-country-dropdown"
                                        onChange={(event) =>
                                          onIRTChange(event?.value, i)
                                        }
                                        defaultValue={
                                          val?.optIrt
                                            ? {
                                                label: "Yes",
                                                value: val?.optIrt,
                                              }
                                            : ""
                                        }
                                        value={
                                          optIRT.findIndex(
                                            (el) => el.value == val?.optIrt,
                                          ) == -1
                                            ? ""
                                            : optIRT[
                                                optIRT.findIndex(
                                                  (el) =>
                                                    el.value == val?.optIrt,
                                                )
                                              ]
                                        }
                                        placeholder="Select IRT"
                                      />
                                    </div>
                                  </div>{" "}
                                  <div className="col-12 col-md-6">
                                    <div className="form-group bottom">
                                      <label for="">
                                        Institution <span>*</span>
                                      </label>
                                      {val?.optIrt == "yes" ? (
                                        <Select
                                          options={irtInstitutionType}
                                          className={
                                            validationError?.newHcpInstitution &&
                                            validationError?.index == i
                                              ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                              : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                          }
                                          onChange={(event) =>
                                            onInstitutionChange(event, i)
                                          }
                                          value={
                                            irtInstitutionType.findIndex(
                                              (el) =>
                                                el.value ==
                                                val?.institutionType,
                                            ) == -1
                                              ? ""
                                              : irtInstitutionType[
                                                  irtInstitutionType.findIndex(
                                                    (el) =>
                                                      el.value ==
                                                      val?.institutionType,
                                                  )
                                                ]
                                          }
                                          isClearable
                                          placeholder="Select institution"
                                        />
                                      ) : val?.optIrt == "no" ? (
                                        <Select
                                          options={nonIrtInstitutionType}
                                          className={
                                            validationError?.newHcpInstitution &&
                                            validationError?.index == i
                                              ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                              : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                          }
                                          onChange={(event) =>
                                            onInstitutionChange(event, i)
                                          }
                                          value={
                                            nonIrtInstitutionType.findIndex(
                                              (el) =>
                                                el.value ==
                                                val?.institutionType,
                                            ) == -1
                                              ? ""
                                              : nonIrtInstitutionType[
                                                  nonIrtInstitutionType.findIndex(
                                                    (el) =>
                                                      el.value ==
                                                      val?.institutionType,
                                                  )
                                                ]
                                          }
                                          isClearable
                                          placeholder="Select institution"
                                        />
                                      ) : null}
                                      {validationError?.newHcpInstitution &&
                                      validationError?.index == i ? (
                                        <div className="login-validation">
                                          {validationError?.newHcpInstitution}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group">
                                      <label for="">
                                        IRT role <span> *</span>
                                      </label>
                                      {val?.optIrt == "yes" ? (
                                        <Select
                                          options={irtRole}
                                          className={
                                            validationError?.role &&
                                            validationError?.index == i
                                              ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                              : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                          }
                                          onChange={(event) =>
                                            onRoleChange(event, i)
                                          }
                                          value={
                                            irtRole?.findIndex(
                                              (el) => el.value == val?.role,
                                            ) == -1
                                              ? ""
                                              : irtRole[
                                                  irtRole?.findIndex(
                                                    (el) =>
                                                      el.value == val?.role,
                                                  )
                                                ]
                                          }
                                          isClearable
                                          placeholder="Select Role"
                                        />
                                      ) : val?.optIrt == "no" ? (
                                        <Select
                                          options={role}
                                          className={
                                            validationError?.role &&
                                            validationError?.index == i
                                              ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                              : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                          }
                                          onChange={(event) =>
                                            onRoleChange(event, i)
                                          }
                                          value={
                                            role?.findIndex(
                                              (el) => el.value == val?.role,
                                            ) == -1
                                              ? ""
                                              : role[
                                                  role?.findIndex(
                                                    (el) =>
                                                      el.value == val?.role,
                                                  )
                                                ]
                                          }
                                          isClearable
                                          placeholder="Select Role"
                                        />
                                      ) : (
                                        <Select
                                          className="dropdown-basic-button split-button-dropup edit-country-dropdown"
                                          placeholder="Select Role"
                                        />
                                      )}
                                      {validationError?.role &&
                                      validationError?.index == i ? (
                                        <div className="login-validation">
                                          {validationError?.role}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group">
                                      <label htmlFor="">Contact type</label>
                                      <DropdownButton
                                        className={`dropdown-basic-button edit-country-dropdown split-button-dropup ${hpc[i].contact_type != "" && hpc[i].contact_type != "undefined" ? "type-selected" : ""}`}
                                        title={
                                          hpc[i].contact_type != "" &&
                                          hpc[i].contact_type != "undefined"
                                            ? hpc[i].contact_type
                                            : "Select Type"
                                        }
                                        onSelect={(event) =>
                                          onContactTypeChange(event, i)
                                        }
                                      >
                                        <Dropdown.Item
                                          eventKey="HCP"
                                          className={
                                            hpc[i].contact_type == "HCP"
                                              ? "active"
                                              : ""
                                          }
                                        >
                                          HCP
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          eventKey="Staff"
                                          className={
                                            hpc[i].contact_type == "Staff"
                                              ? "active"
                                              : ""
                                          }
                                        >
                                          Staff
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          eventKey="Test Users"
                                          className={
                                            hpc[i].contact_type == "Test Users"
                                              ? "active"
                                              : ""
                                          }
                                        >
                                          Test Users
                                        </Dropdown.Item>
                                      </DropdownButton>
                                    </div>
                                  </div>
                                </>
                              )}

                              <div className="col-12 col-md-6">
                                <div className="form-group">
                                  <label htmlFor="">
                                    Country{" "}
                                    {isLikeRdAccount && <span>*</span>}{" "}
                                  </label>
                                  {val?.optIrt == "yes" ? (
                                    <>
                                      <Select
                                        options={irtCountry}
                                        className={
                                          validationError?.index == i &&
                                          validationError?.newHcpCountry
                                            ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                            : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                        }
                                        onChange={(event) =>
                                          onCountryChange(event, i)
                                        }
                                        value={
                                          irtCountry.findIndex(
                                            (el) => el.value == val?.country,
                                          ) == -1
                                            ? ""
                                            : irtCountry[
                                                irtCountry.findIndex(
                                                  (el) =>
                                                    el.value == val?.country,
                                                )
                                              ]
                                        }
                                        placeholder="Select Country"
                                        filterOption={createFilter(
                                          filterConfig,
                                        )}
                                        isClearable
                                      />

                                      {validationError?.newHcpCountry &&
                                        validationError?.index == i && (
                                          <div className="login-validation">
                                            {validationError?.newHcpCountry}
                                          </div>
                                        )}
                                    </>
                                  ) : (
                                    <>
                                      <Select
                                        options={countryall}
                                        className={
                                          validationError?.index == i &&
                                          validationError?.newHcpCountry
                                            ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                            : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                        }
                                        ss
                                        onChange={(event) =>
                                          onCountryChange(event, i)
                                        }
                                        value={
                                          countryall.findIndex(
                                            (el) => el.value == val?.country,
                                          ) == -1
                                            ? ""
                                            : countryall[
                                                countryall.findIndex(
                                                  (el) =>
                                                    el.value == val?.country,
                                                )
                                              ]
                                        }
                                        placeholder="Select Country"
                                        filterOption={createFilter(
                                          filterConfig,
                                        )}
                                        isClearable
                                      />
                                      {validationError?.newHcpCountry &&
                                        validationError?.index == i && (
                                          <div className="login-validation">
                                            {validationError?.newHcpCountry}
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </div>

                              {isLikeRdAccount ? (
                                <>
                                  {" "}
                                  <div className="col-12 col-md-6">
                                    <div className="form-group">
                                      <label for="">
                                        Site number{" "}
                                        {val?.optIrt == "yes" ? (
                                          <span> *</span>
                                        ) : null}
                                      </label>

                                      <Select
                                        options={siteNumberAll}
                                        className={
                                          validationError?.index == i &&
                                          validationError?.newSiteNumber
                                            ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                            : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                        }
                                        onChange={(event) =>
                                          onSiteNumberChange(event, i)
                                        }
                                        value={
                                          siteNumberAll[hpc[i]?.siteNumberIndex]
                                            ? siteNumberAll[
                                                hpc[i]?.siteNumberIndex
                                              ]
                                            : ""
                                        }
                                        placeholder={"Select Site Number"}
                                      />
                                      {validationError?.newSiteNumber &&
                                      validationError?.index == i ? (
                                        <div className="login-validation">
                                          {validationError?.newSiteNumber}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6">
                                    <div className="form-group">
                                      <label for="">
                                        Site name{" "}
                                        {val?.optIrt == "yes" ? (
                                          <span> *</span>
                                        ) : null}
                                      </label>

                                      <Select
                                        options={siteNameAll}
                                        className={
                                          validationError?.index == i &&
                                          validationError?.newSiteName
                                            ? "dropdown-basic-button split-button-dropup edit-country-dropdown error"
                                            : "dropdown-basic-button split-button-dropup edit-country-dropdown"
                                        }
                                        onChange={(event) =>
                                          onSiteNameChange(event, i)
                                        }
                                        value={
                                          siteNameAll[hpc[i].siteNameIndex]
                                            ? siteNameAll[hpc[i].siteNameIndex]
                                            : ""
                                        }
                                        placeholder={"Select Site Name"}
                                      />
                                      {validationError?.newSiteName &&
                                      validationError?.index == i ? (
                                        <div className="login-validation">
                                          {validationError?.newSiteName}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="hcp-modal-action">
                            <div className="hcp-action-block">
                              {activeManual == "active" ? (
                                <>
                                  {hpc.length > 1 && (
                                    <div className="hcp-remove">
                                      <button
                                        type="button"
                                        className="btn btn-filled"
                                        onClick={() => deleteRecord(i)}
                                      >
                                        <img
                                          src={path_image + "delete.svg"}
                                          alt="Delete Row"
                                        />
                                      </button>
                                    </div>
                                  )}
                                </>
                              ) : null}

                              <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item add_hcp">
                                  <a
                                    id="add_hcp_btn"
                                    onClick={addMoreHcp}
                                    className="nav-link active btn-bordered"
                                    data-bs-toggle="tab"
                                    href="#add_hcp_form"
                                  >
                                    {isLikeRdAccount
                                      ? "Add User +"
                                      : "Add HCP +"}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </form>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary save btn-filled"
              onClick={saveClicked}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

const TableRow = memo(
  ({
    reader,
    index,
    listType,
    setRestrictedUsers,
    setReadersNewlyAdded,
    setRemovedReaders,
    setReaders,
    editable,
    isVwdFlow,
    addRestrictedToNewlyAdded,
    removeNewlyAddedToRestricted,
    readersAdded,
    deleteReader,
    editing,
  }) => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
    const [regions, setRegions] = useState([]);
    const [count, setCount] = useState(0);
    useEffect(() => {
      setRegions(
        Array.from([...new Set(Object.values(countryRegionArray))]).map(
          (item) => ({
            label: item,
            value: item,
          }),
        ),
      );
    }, []);

    const countries = useMemo(() => {
      let entries = Object.entries(countryRegionArray);
      if (reader.selectedRegion?.value)
        entries = entries.filter((e) => e[1] === reader.selectedRegion?.value);
      return entries.map((item) => ({ label: item[0], value: item[0] }));
    }, [count]);

    const handleInputChange = useCallback(
      (type, val) => {
        const funRef =
          listType === "restricted"
            ? setRestrictedUsers
            : listType === "added"
              ? setReadersNewlyAdded
              : listType === "deleted"
                ? setRemovedReaders
                : setReaders;

        funRef((prev) => {
          return prev.map((item) => {
            if (item.user_id == reader.user_id && type === "region") {
              let country;
              if (val?.value)
                country = Object.entries(countryRegionArray).filter(
                  (e) => e[1] === val?.value,
                )[0];
              else country = Object.entries(countryRegionArray)[0];
              return {
                ...item,
                selectedRegion: val,
                selectedCountries: {
                  label: country[0],
                  value: country[0],
                },
              };
            } else if (item.user_id == reader.user_id && type === "country") {
              return {
                ...item,
                selectedCountries: val,
                selectedRegion: {
                  label: countryRegionArray[val?.value],
                  value: countryRegionArray[val?.value],
                },
              };
            } else return item;
          });
        });
        setCount((prev) => prev + 1);
      },
      [reader],
    );

    return (
      <React.Fragment key={index}>
        <tr
          id={`row-selected` + index}
          onClick={() => editing(reader.user_id, reader.email)}
        >
          {/* Name - Editable */}
          <td
            id={`field_name` + reader.user_id}
            contentEditable={editable === 0 ? "false" : "true"}
            className={editable !== 0 ? "editable-cell" : ""}
          >
            <span>{reader.name ? reader.name : "N/A"}</span>
          </td>

          {/* Email - NOT Editable */}
          <td id={`field_email` + reader.user_id} className="non-editable-cell">
            {reader.email ? reader.email : "N/A"}
          </td>

          {isVwdFlow && (
            <>
              {/* Role - Editable */}
              <td
                id={`field_role` + reader.user_id}
                contentEditable={editable === 0 ? "false" : "true"}
                className={editable !== 0 ? "editable-cell" : ""}
              >
                <span>{reader.role || "N/A"}</span>
              </td>

              {/* Company - Editable */}
              <td
                id={`field_company` + reader.user_id}
                contentEditable={editable === 0 ? "false" : "true"}
                className={editable !== 0 ? "editable-cell" : ""}
              >
                <span>{reader.company || "N/A"}</span>
              </td>

              {/* Region - Editable */}

              <td>
                {editable ? (
                  <Select
                    options={regions}
                    className="dropdown-basic-button split-button-dropup edit-country-dropdown"
                    onChange={(event) => handleInputChange("region", event)}
                    value={
                      reader.selectedRegion || {
                        label: reader.region,
                        value: reader.region,
                      }
                    }
                    id={"field_region" + reader.user_id}
                    placeholder={"Select Region"}
                    isClearable
                  />
                ) : (
                  <span>{reader.region ? reader.region : "N/A"}</span>
                )}
              </td>
            </>
          )}

          <input
            type="hidden"
            id={`field_index` + reader.user_id}
            value={index}
          />

          {/* Country - Editable via dropdown */}
          <td>
            {editable ? (
              <Select
                options={countries}
                className="dropdown-basic-button split-button-dropup edit-country-dropdown"
                onChange={(event) => handleInputChange("country", event)}
                value={
                  reader.selectedCountries || {
                    label: reader.country,
                    value: reader.country,
                  }
                }
                id={"field_country" + reader.user_id}
                placeholder={"Select Countries"}
                isClearable
              />
            ) : (
              <span>{reader.country ? reader.country : "N/A"}</span>
            )}
          </td>

          {isVwdFlow && (
            <>
              {/* Join Date - NOT Editable */}
              <td className="non-editable-cell">
                {reader.created
                  ? new Date(reader.created).toLocaleDateString()
                  : "N/A"}
              </td>
            </>
          )}
          {isVwdFlow && (
            <>
              {/* last Date - NOT Editable */}
              <td className="non-editable-cell" style={{ color: "#0066BE" }}>
                {reader.lastActivity
                  ? new Date(reader.lastActivity).toLocaleDateString()
                  : "N/A"}
              </td>
            </>
          )}

          {/* Action buttons */}
          <td className="delete_row" colSpan="12">
            {listType === "restricted" && (
              <img
                src={path_image + "add-user.svg"}
                alt="Add Row"
                title="Add to newly added"
                style={{ cursor: "pointer" }}
                className="add"
                onClick={(e) => {
                  e.stopPropagation();
                  addRestrictedToNewlyAdded(reader, index);
                }}
              />
            )}
            {listType === "added" && (
              <img
                src={path_image + "delete.svg"}
                alt="Delete Row"
                title="Remove and move back to restricted"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  removeNewlyAddedToRestricted(reader, index);
                }}
              />
            )}
            {listType === "deleted" && (
              <img
                src={path_image + "add-user.svg"}
                alt="Add Back"
                title="Add back to HCPs"
                style={{ cursor: "pointer" }}
                className="add"
                onClick={(e) => {
                  e.stopPropagation();
                  readersAdded(reader, index);
                }}
              />
            )}
            {listType === "hcp" && (
              <img
                src={path_image + "delete.svg"}
                alt="Delete Row"
                onClick={() => deleteReader(index)}
              />
            )}
          </td>
        </tr>
      </React.Fragment>
    );
  },
);

const UserTable = ({
  data,
  type,
  sortBy,
  sortOrder,
  handleSort,
  sortData,
  renderTableRow,
}) => {
  const headers = [
    { key: "name", val: "Name" },
    { key: "email", val: "Email" },
    { key: "role", val: "Role" },
    { key: "company", val: "Company" },
    { key: "region", val: "Region" },
    { key: "country", val: "Country" },
    { key: "created", val: "Join Date" },
    { key: "lastActivity", val: "Last Activity" },
  ];
  return (
    <div className="selected-hcp-list vwd">
      <table className="table">
        <thead>
          <tr>
            {headers.map((d) => (
              <th key={d.key} scope="col" className="sort_option">
                <span
                  onClick={() => handleSort(d.key, type)}
                  style={{ cursor: "pointer" }}
                >
                  {d.val}
                  <button
                    className={`event_sort_btn ${sortBy[type] === d.key ? (sortOrder[type] === "asc" ? "svg_asc" : "svg_active") : ""}`}
                  >
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path
                        d="M7.00015 5.19137L4.3311 7.84461C4.28138 7.89413 4.22222 7.93328 4.15708 7.95976C4.02649 8.01341 3.87983 8.01341 3.74925 7.95976C3.6841 7.93328 3.62494 7.89413 3.57522 7.84461L0.90617 5.19137C0.806076 5.09173 0.7499 4.95664 0.75 4.81582C0.7501 4.67501 0.806468 4.54 0.906704 4.4405L3.41988 6.18845L3.41357 0.530648C3.41357 0.389912 3.46981 0.254939 3.56992 0.155423C3.67003 0.0559068 3.8058 0 3.94738 0C4.08895 0 4.22473 0.0559068 4.32484 0.155423L4.48751 6.18845L6.24534 4.44103C6.34602 4.34437 6.48086 4.29209 6.62083 4.29209C7.09739 5.09129 7.00015 5.19137Z"
                        fill="#97B6CF"
                      />
                    </svg>
                  </button>
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            sortData(data, sortBy[type], sortOrder[type]).map((user, i) =>
              renderTableRow(user, i, type),
            )
          ) : (
            <tr className="no-user-selected">
              <td colSpan="12">No User Found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => {
  old_object = state.getEmailData ? state.getEmailData : {};
  return state;
};

export default connect(mapStateToProps, {
  getEmailData: getEmailData,
})(VwdUserDetails);
